export const createBankAgreementSignBkiFormRepository = (appFetch) => {
    return {
        send(slug, body, options = {}) {
            return appFetch.post(`/cabinet/business-creditform/api/agreement/${slug}`, body, options);
        },
        chiefPosition(body, options = {}) {
            return appFetch.post('/cabinet/business-creditform/api/preload/chief-position', body, options);
        },
    };
};
